module.exports = __webpack_public_path__ + "static/media/programming-code-signs-svgrepo-com.a9225112.svg";